// TOP サービス一覧の SP スライダー（Swiper）。
// カテゴリボタンと連動し、タップで該当カードへスライド＋アクティブ表示を切り替える。
// PC では init せず、md（max-width:768px）境界で init / destroy する。
// Swiper は CDN（window.Swiper）前提。未読み込みなら何もしない。

const SP_QUERY = '(max-width: 768px)'; // DaiCSS の md（767）に一致

const topServicesSlider = () => {
  const SwiperLib = window.Swiper;
  if (!SwiperLib) return;

  const container = document.querySelector('.js-top-services-slider');
  if (!container) return;

  const cats = Array.from(document.querySelectorAll('.js-top-services-cat'));
  const pagination = document.querySelector('.js-top-services-pagination');
  const sliderWrapper = container.closest('.m-top-services__slider');
  let swiper = null;

  const syncActiveCat = () => {
    if (!swiper) return;
    cats.forEach((cat, i) =>
      cat.classList.toggle('is-active', i === swiper.realIndex),
    );
  };

  // 全スライド（loop 用クローン含む）の title / text 高さを最大値に揃える。
  // subgrid は Swiper の flex wrapper では効かないため JS で min-height を当てる。
  const getSlideTextNodes = () => {
    const nodes = { titles: [], texts: [] };
    container.querySelectorAll('.swiper-slide').forEach((slide) => {
      const t = slide.querySelector('.m-top-services__title');
      const tx = slide.querySelector('.m-top-services__text');
      if (t) nodes.titles.push(t);
      if (tx) nodes.texts.push(tx);
    });
    return nodes;
  };

  const equalizeSlideHeights = () => {
    const { titles, texts } = getSlideTextNodes();
    // 一度リセットしてから自然な高さを再計測
    [...titles, ...texts].forEach((el) => {
      el.style.minHeight = '';
    });
    if (titles.length) {
      const max = Math.max(...titles.map((el) => el.offsetHeight));
      titles.forEach((el) => {
        el.style.minHeight = `${max}px`;
      });
    }
    if (texts.length) {
      const max = Math.max(...texts.map((el) => el.offsetHeight));
      texts.forEach((el) => {
        el.style.minHeight = `${max}px`;
      });
    }
  };

  const resetSlideHeights = () => {
    const { titles, texts } = getSlideTextNodes();
    [...titles, ...texts].forEach((el) => {
      el.style.minHeight = '';
    });
  };

  const init = () => {
    if (swiper) return;
    // 1件以下はスライダー化しない。2件は loop なし。3件以上で従来通り loop + 中央寄せ
    const slideCount = container.querySelectorAll('.swiper-slide').length;
    if (slideCount <= 1) {
      pagination?.setAttribute('hidden', '');
      return;
    }
    pagination?.removeAttribute('hidden');

    swiper = new SwiperLib(container, {
      loop: slideCount >= 3,
      centeredSlides: slideCount >= 3,
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 400,
      pagination: { el: pagination, clickable: true },
      on: { slideChange: syncActiveCat },
    });
    syncActiveCat();
    equalizeSlideHeights();
  };

  const destroy = () => {
    if (!swiper) return;
    swiper.destroy(true, true);
    swiper = null;
    cats.forEach((cat) => cat.classList.remove('is-active'));
    resetSlideHeights();
  };

  // フォント読込完了後に再計測（Zen Maru Gothic が遅延読込のケースに備えて）
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      if (swiper) equalizeSlideHeights();
    });
  }

  // リサイズで再計測（向き変更・ブラウザ幅変化）
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    if (!swiper) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeSlideHeights, 200);
  });

  // カテゴリボタン → 対応スライドへ＋スライダー位置までスクロール（SP のときだけ swiper が存在）
  cats.forEach((cat, i) => {
    cat.addEventListener('click', (e) => {
      e.preventDefault();
      if (!swiper) return;
      swiper.slideToLoop(i);
      if (!sliderWrapper) return;
      const headerEl = document.getElementById('js-header');
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;
      const top =
        sliderWrapper.getBoundingClientRect().top +
        window.scrollY -
        headerHeight -
        16;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  const mq = window.matchMedia(SP_QUERY);
  const handleChange = () => (mq.matches ? init() : destroy());
  mq.addEventListener('change', handleChange);
  handleChange();
};

export { topServicesSlider };
